import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SharedLavorazioniModule } from '../../../lavorazioni/modules/shared-lavorazioni/shared-lavorazioni.module';
import { ConnectServerService } from '../../../../../../services/connect-server.service';
import { TranslateService } from '@ngx-translate/core';
import { DashboardStatusWeco, DashboardTicketAssignedWeco, DashboardWeco } from './dashboard-weco';
import { ApiResponse } from '../../../../../../interfaces/api-response';
import { TicketFilterService } from '../../../lavorazioni/ticket-s/ticket-filter.service';
import { SystemsListStateService } from '../../../lavorazioni/systems/systems-list/services/systems-list-state.service';
import { CommesseListaDettStateService } from '../../../lavorazioni/commesse/commesse-lista-dett/services/commesse-lista-dett-state.service';
import { TableAssignedTicketSComponent } from "./table-assigned-ticket-s/table-assigned-ticket-s.component";

@Component({
  selector: 'app-dashboard-weco',
  imports: [
    SharedLavorazioniModule, CommonModule, RouterModule
],
  templateUrl: './dashboard-weco.component.html',
  styleUrl: './dashboard-weco.component.scss',
})
export class DashboardWecoComponent {
  dashboardData: DashboardWeco[] = [];
  dashboardTicketAssigned: DashboardTicketAssignedWeco | null = null;
  lang: string = 'it';

  constructor(private connectServerService: ConnectServerService,
    private translateService: TranslateService,
    private ticketFilterService: TicketFilterService,
    private systemsListStateService: SystemsListStateService,
    private commesseStateService: CommesseListaDettStateService,
    private router: Router){
    this.lang = this.translateService.currentLang || 'it';
  }

  ngOnInit(): void {
    this._getDashboardData();
  }

  private _getDashboardData(): void {
    this.connectServerService.getRequestCookie('infogeneral/dashboard', {})
      .subscribe((response: ApiResponse<{ weco: { ticket: any; system: any; orders: any; ticket_assigned: any } }>) => {
        const weco = response.data?.weco;
        if (!weco) {
          return;
        }

        const cards: DashboardWeco[] = [];
        if (weco.ticket) {
          cards.push({
            ...weco.ticket,
            status: this._normalizeStatus(weco.ticket.status),
            filterType: 'ticket',
          });
        }
        if (weco.orders) {
          cards.push({
            ...weco.orders,
            status: this._normalizeStatus(weco.orders.status),
            filterType: 'order',
          });
        }
        if (weco.system) {
          cards.push({
            ...weco.system,
            status: this._normalizeStatus(weco.system.status),
            filterType: 'system',
          });
        }

        this.dashboardData = cards;
        this.dashboardTicketAssigned = weco.ticket_assigned ?? null;
      });
  }

  /**
   * Normalizza i due formati che può avere l'array status dal server:
   * - Ticket: ogni elemento ha { status: {...}, substatus: {...}, count, percentage }
   * - Altri:  ogni elemento ha { id, name_it, name_en, color, count, percentage }
   */
  private _normalizeStatus(rawStatuses: any[]): DashboardStatusWeco[] {
    return (rawStatuses ?? []).map(s => {
      if (s.substatus !== undefined) {
        // Formato ticket: mostra il nome del substatus se non è "---"
        const useSubName = s.substatus.name_it !== '---';
        return {
          id: s.substatus.id,
          idParent: s.status.id,
          name_it: useSubName ? s.substatus.name_it : s.status.name_it,
          name_en: useSubName ? s.substatus.name_en : s.status.name_en,
          color: s.status.color ?? null,
          count: s.count,
          percentage: s.percentage
        };
      } else {
        // Formato piatto (impianti, commesse)
        return {
          id: s.id,
          name_it: s.name_it,
          name_en: s.name_en,
          color: s.color ?? null,
          count: s.count,
          percentage: s.percentage
        };
      }
    });
  }

  getTranslateName(name_it: string, name_en: string): string {
    return this.lang === 'it' ? name_it : name_en;
  }

  navigateWithStatusFilter(data: DashboardWeco, status: DashboardStatusWeco): void {
    if (!data.path_table) return;

    switch (data.filterType) {
      case 'ticket':
        this.ticketFilterService.setStatusFilter({
          idstatus: status.idParent ?? 0,
          idsubstatus: status.id,
          name_status: this.getTranslateName(status.name_it, status.name_en),
          name_substatus: this.getTranslateName(status.name_it, status.name_en)
        });
        break;
      case 'system':
        this.systemsListStateService.setStatusFilterFromDashboard(status.id);
        break;
      case 'order':
        this.commesseStateService.setStatusFilterFromDashboard(status.id);
        break;
    }

    this.router.navigate(['/' + data.path_table]);
  }
}
